import { render, staticRenderFns } from "./SingleGroupQuestionView.vue?vue&type=template&id=086f5d8f&scoped=true&"
import script from "./SingleGroupQuestionView.vue?vue&type=script&lang=js&"
export * from "./SingleGroupQuestionView.vue?vue&type=script&lang=js&"
import style0 from "./SingleGroupQuestionView.vue?vue&type=style&index=0&id=086f5d8f&scoped=true&lang=css&"
import style1 from "./SingleGroupQuestionView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f5d8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
